module.exports = __webpack_public_path__ + "static/musee_olympique_stades-0294e6afe69b2af991909ba9f50bf2e6.png";